import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import * as React from 'react';
import { NtcList } from 'z3k-settings/climatic/ntc_sensors/ui/ntc-list';
import { unpack_validation } from 'z3k-parser/validation/types';
export function ClimaticNtcSensors() {
    return (_jsx(Box, { sx: { px: 2, pb: '6px' }, children: _jsx(NtcList, {}) }));
}
ClimaticNtcSensors.isWarning = () => false;
ClimaticNtcSensors.isError = (validation_result) => {
    return !!unpack_validation(validation_result, 'analog_temperature_sensors');
};
ClimaticNtcSensors.isShown = (is_service_view, config, spec, is_staff, is_climatic) => {
    return is_service_view && is_climatic;
};
